import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hospital, Shield, Car, FileText, Coffee } from 'lucide-react';

interface FooterNavItem {
  id: string;
  labelKey: string;
  icon: React.ReactNode;
  path: string;
  isActive: boolean;
}

export const MobileFooterNav: React.FC = () => {
  const { t } = useTranslation('common');
  const navItems: FooterNavItem[] = [
    {
      id: 'hospitals',
      labelKey: 'categories.hospitals',
      icon: <Hospital className="w-5 h-5" />,
      path: '/search',
      isActive: true,
    },
    {
      id: 'insurance',
      labelKey: 'categories.insurancePlans',
      icon: <Shield className="w-5 h-5" />,
      path: '#',
      isActive: false,
    },
    {
      id: 'gas',
      labelKey: 'categories.gas',
      icon: <Car className="w-5 h-5" />,
      path: '#',
      isActive: false,
    },
    {
      id: 'taxes',
      labelKey: 'categories.taxes',
      icon: <FileText className="w-5 h-5" />,
      path: '#',
      isActive: false,
    },
    {
      id: 'food',
      labelKey: 'categories.fastFood',
      icon: <Coffee className="w-5 h-5" />,
      path: '#',
      isActive: false,
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t-2 border-amber-300" style={{ bottom: '64px' }}>
      {/* Footer Navigation */}
      <div className="bg-gradient-to-r from-amber-100 via-yellow-100 to-orange-100 shadow-2xl">
        <div className="flex items-center justify-around px-4 py-3 w-full">
          {navItems.map((item) => (
            <div key={item.id} className="flex-1">
              {item.isActive ? (
                <Link
                  to={item.path}
                  className="flex flex-col items-center justify-center py-3 px-2 rounded-lg bg-emerald-200 border border-emerald-400 transition-all duration-200 hover:bg-emerald-300"
                >
                  <div className="text-emerald-700 mb-1">
                    {item.icon}
                  </div>
                  <span className="text-xs font-bold text-emerald-900 text-center leading-tight">
                    {t(item.labelKey)}
                  </span>
                </Link>
              ) : (
                <div className="flex flex-col items-center justify-center py-3 px-2 rounded-lg opacity-70 cursor-not-allowed">
                  <div className="text-gray-600 mb-1">
                    {item.icon}
                  </div>
                  <span className="text-xs font-medium text-gray-700 text-center leading-tight">
                    {t(item.labelKey)}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};